export const Regex = {
  email: /^[A-Z0-9.!#$%&'*+-/=?^_`{|}~]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
  phone: /^9\d{8}$/,
  carPlate: /^[a-zA-Z0-9]{6,8}$/,
  onlyString: /^[a-zA-ZñÑáéíóúÁÉÍÓÚ\s]*$/i,
  onlyNumber: /^[0-9]+$/,
};